import React from 'react';
import { useNavigate } from 'react-router-dom';

const Goal15 = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/#sdg-goals');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <button
        onClick={handleGoBack}
        className="mb-6 flex items-center text-gray-600 hover:text-gray-900 transition-colors duration-200"
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Go Back
      </button>
      <h2 className="text-3xl font-bold mb-4">SDG 15 Life on Land</h2>
      <p className="mb-4">
        Sustainably manage forests, combat desertification, halt and reverse land degradation, halt biodiversity loss.
      </p>
      <a
        href="https://sdg-tracker.org/biodiversity"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline mb-6 inline-block"
      >
        https://sdg-tracker.org/biodiversity
      </a>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No.</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">targets</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Target Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.1</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Conserve and restore terrestrial and freshwater ecosystems</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, ensure the conservation, restoration and sustainable use of terrestrial and inland freshwater ecosystems and their services, in particular forests, wetlands, mountains and drylands, in line with obligations under international agreements.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.2</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">End deforestation and restore degraded forests</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, promote the implementation of sustainable management of all types of forests, halt deforestation, restore degraded forests and substantially increase afforestation and reforestation globally.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.3</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">End desertification and restore degraded land</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, combat desertification, restore degraded land and soil, including land affected by desertification, drought and floods, and strive to achieve a land degradation-neutral world.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.4</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Ensure conservation of mountain ecosystems</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, ensure the conservation of mountain ecosystems, including their biodiversity, in order to enhance their capacity to provide benefits that are essential for sustainable development.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.5</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Protect biodiversity and natural habitats</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Take urgent and significant action to reduce the degradation of natural habitats, halt the loss of biodiversity and, by 2020, protect and prevent the extinction of threatened species.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.6</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Protect access to genetic resources and fair sharing of the benefits</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Promote fair and equitable sharing of the benefits arising from the utilization of genetic resources and promote appropriate access to such resources, as internationally agreed.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.7</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Eliminate poaching and trafficking of protected species</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Take urgent action to end poaching and trafficking of protected species of flora and fauna and address both demand and supply of illegal wildlife products.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.8</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Prevent invasive alien species on land and in water ecosystems</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, introduce measures to prevent the introduction and significantly reduce the impact of invasive alien species on land and water ecosystems and control or eradicate the priority species.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.9</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Integrate ecosystem and biodiversity in governmental planning</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, integrate ecosystem and biodiversity values into national and local planning, development processes, poverty reduction strategies and accounts.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.A</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Increase financial resources to conserve and sustainably use ecosystem and biodiversity</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Mobilize and significantly increase financial resources from all sources to conserve and sustainably use biodiversity and ecosystems.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.B</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Finance and incentivize sustainable forest management</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Mobilize significant resources from all sources and at all levels to finance sustainable forest management and provide adequate incentives to developing countries to advance such management, including for conservation and reforestation.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">15.C</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Combat global poaching and trafficking</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Enhance global support for efforts to combat poaching and trafficking of protected species, including by increasing the capacity of local communities to pursue sustainable livelihood opportunities.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Goal15;
